import React from 'react';
import Navbar from '../components/Navbar';
import BetaBanner from '../components/BetaBanner';
import Hero from '../components/Hero';
import RollingTicker from '../components/RollingTicker';
import TrustStrip from '../components/TrustStrip';
import FloatingCTA from '../components/FloatingCTA';

/**
 * Landing page — strictly one viewport, no scroll. BetaBanner + Navbar + Hero +
 * RollingTicker + TrustStrip stack to exactly h-screen. A small dismissible
 * golden popup (FloatingCTA) pinned bottom-right invites sign-up. No footer on
 * landing (other pages still get the full footer via their own routes).
 */
export default function Home() {
  return (
    <div className="h-screen overflow-hidden bg-[#0A0A0B] flex flex-col">
      <BetaBanner />
      <Navbar />

      <main className="flex-1 flex flex-col min-h-0">
        <Hero />
        <div className="mt-auto">
          <RollingTicker />
          <TrustStrip />
        </div>
      </main>

      <FloatingCTA />
    </div>
  );
}
